export default "__VITE_PUBLIC_ASSET__d428e023__"